import React from 'react';

import { BringgInput, Button, FormItem } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import type { Rule } from 'antd/lib/form';

import styles from './domain-input-row.module.scss';

interface DomainInputRowProps {
	index: number;
	fieldName: number;
	placeholder: string;
	rules: Rule[];
	onRemove: () => void;
}

export const DomainInputRow: React.FC<DomainInputRowProps> = ({ index, fieldName, placeholder, rules, onRemove }) => {
	return (
		<div className={styles.domainRow} data-test-id={`domain-row-${index}`}>
			<div className={styles.domainInputWrapper}>
				<FormItem
					name={fieldName}
					rules={rules}
					validateTrigger={['onBlur', 'onSubmit']}
					className={styles.domainFormItem}
				>
					<BringgInput placeholder={placeholder} data-test-id={`domain-input-${index}`} />
				</FormItem>
			</div>
			<Button
				type="text"
				className={styles.removeDomainBtn}
				onClick={onRemove}
				data-test-id={`remove-domain-${index}`}
			>
				<BringgIcon iconName={BringgFontIcons.Close} />
			</Button>
		</div>
	);
};
